var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100"
  }, [_c('v-img', {
    staticClass: "w-100 mb-12 mb-lg-24",
    attrs: {
      "src": _vm.src
    }
  }), _vm.tit ? _c('h5', {
    staticClass: "tit--sm font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]) : _vm._e(), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }